"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
var core_1 = require("@material-ui/core");
var useStyles = (0, makeStyles_1.default)(function (theme) {
    var _a, _b, _c;
    return ({
        root: (_a = {
                paddingTop: 34,
                paddingBottom: 34,
                paddingLeft: 16,
                paddingRight: 16
            },
            _a[theme.breakpoints.up('sm')] = {
                paddingTop: 49,
                paddingBottom: 35,
                paddingLeft: 40,
                paddingRight: 40,
            },
            _a),
        title: (_b = {
                width: '70%'
            },
            _b[theme.breakpoints.up('sm')] = {
                width: '100%',
            },
            _b),
        divider: (_c = {
                marginTop: 15,
                marginBottom: 30,
                marginLeft: -16,
                marginRight: -16
            },
            _c[theme.breakpoints.up('sm')] = {
                paddingLeft: -40,
                paddingRight: -40,
            },
            _c),
    });
});
function BaseStatisticsLayout(_a) {
    var children = _a.children, title = _a.title, subtitle = _a.subtitle;
    var classes = useStyles();
    var theme = (0, core_1.useTheme)();
    var isMobileView = (0, useMediaQuery_1.default)(theme.breakpoints.down('xs'));
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(Typography_1.default, { color: "primary", variant: isMobileView ? 'h6' : 'h4', className: classes.title }, title),
        subtitle,
        react_1.default.createElement("div", { className: classes.divider }),
        children));
}
exports.default = BaseStatisticsLayout;
